import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Icon,
  VStack,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
  Input,
  RadioGroup,
  Radio,
  Stack,
  Checkbox,
  Textarea,
  Switch,
  Box,
  useToast,
  IconButton,
  CloseButton,
  UnorderedList,
  ListItem,
  Text,
  HStack,
  Select,
  Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverBody, PopoverArrow, PopoverCloseButton, Portal,
  InputGroup,
  InputRightElement,
  AccordionPanel,
  AccordionIcon,
  AccordionButton,
  AccordionItem,
  Accordion,
  Link,
} from "@chakra-ui/react";
import { ArrowForwardIcon, ArrowBackIcon, CloseIcon, CheckIcon, EditIcon, } from "@chakra-ui/icons";
import { MdInfo, MdDelete, MdCheckCircle } from 'react-icons/md';
import { FaExternalLinkAlt, FaCheck } from 'react-icons/fa';
import { useState, useEffect, useRef } from "react";
import { useSession } from '../SessionContext';
import { useNavigate } from "react-router-dom";
import logout from "../services/authService";
import createAxiosInstance from "../interceptors/useAxiosInterceptors";
import { react_api } from "../config";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import { useTranslation } from "react-i18next";
import SpinnerXL from "./SpinnerXL";
import { hasAccents } from "../services/utils";
import { useDisclosure } from "@chakra-ui/react";
import { MultiSelect } from "react-multi-select-component";
import { initSurveyService, insertValidationMetadataMl } from "../services/http/surveyHttpService";

const options = [
  { label: "TN", value: "TN" },
  { label: "Under review", value: "Under review" },
  { label: "Peer reviewed", value: "Peer reviewed"},
  { label: "Published", value: "Published" }
];



function MetadataModal({ isOpen, onClose, content, removeStagingAreaItem }) {
  const { t } = useTranslation();
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [page, setPage] = useState(1);


  const [maxNumberPage, setMaxNumberPage] = useState(7);

  const licenseDescriptions = {
    "CC BY": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccBy'),
    "CC BY-NC": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccByNc'),
    "CC BY-ND": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccByNd'), 
    "CC BY-SA": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccBySa'), 
    "CC BY-NC-SA": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccByNcSa'), 
    "CC BY-NC-ND": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccByNcNd'), 
    "CC0": t('catalog.stagingArea.metadataModal.licencesDescriptions.cc0'), 
    "CC Plus": t('catalog.stagingArea.metadataModal.licencesDescriptions.ccPlus')
  };

  const [metadataEntered, setMetadataEntered] = useState(false);
  const [metadataEnteredData, setMetadataEnteredData] = useState([]);

  const [payloadUploadMetadata, setPayloadUploadMetadata] = useState({ encoding: "utf8", visibility: "private", generatedByML: false });


  const [payloadValidationMetadataMl, setPayloadValidationMetadataMl] = useState({ papers_type:[], papers_reference:[], papers_urls:[]});


  const [isModal1Open, setIsModal1Open] = useState(true);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [step, setStep] = useState(null);

  // const fileFormats = [
  //   { label: "csv", value: [".csv"] },
  //   { label: "xlsx", value: [".xlsx", ".xls"] }
  // ];
  // const [selectedFileFormat, setSelectedFileFormat] = useState(fileFormats[0].value);
  const defaultPayloadUploadRequestValue = { file: null }
  const [payloadUploadRequest, setPayloadUploadRequest] = useState(defaultPayloadUploadRequestValue);
  const fileSelectorRef = useRef(null);

  const [previousMetadataPayload, setPreviousMetadataPayload] = useState(null);
  const [savedEmptyColumns, setSavedEmptyColumns] = useState(new Set());

  const itemsPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * itemsPage;
  const endIndex = startIndex + itemsPage;
  const currentItems = metadataEnteredData.slice(startIndex, endIndex);

  const [currentUrl, setCurrentUrl] = useState("");
  const [isValidating, setIsValidating] = useState(false);

    const [newPaperUrl, setNewPaperUrl] = useState("");

    const [newPaperReference, setNewPaperReference] = useState("");
  
    const [papersType, setPapersType] = useState([]);


    const handleAddPaperUrl = () => {
      const trimmedUrl = newPaperUrl.trim();
      if (trimmedUrl === "") return;
      if (!/^https?:\/\//i.test(trimmedUrl)) {
        toast({
          title: t('toastMsg.metadataModal.invalidFormatUrl'),
          position: 'top',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
        return;
      }
      if (payloadValidationMetadataMl.papers_urls.includes(trimmedUrl)) {
        toast({
          title: t('toastMsg.metadataModal.existsUrl'),
          position: 'top',
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }
        setPayloadValidationMetadataMl(prevState => ({
          ...prevState,
          papers_urls: [...prevState.papers_urls, trimmedUrl],
        }));

        setNewPaperUrl("");
    };
  
    const handleRemovePaperUrl = (index) => {
      setPayloadValidationMetadataMl(prevState => ({
        ...prevState,
        papers_urls: prevState.papers_urls.filter((_, i) => i !== index),
      }));
      
    };


    const handleAddPaperReference = () => {
      if (newPaperReference.trim() !== "") {
      
        setPayloadValidationMetadataMl(prevState => ({
          ...prevState,
          papers_reference: [...prevState.papers_reference, newPaperReference.trim()],
        }));
        setNewPaperReference("");
      }

      
    };
  
    const handleRemovePaperReference = (index) => {
     
      setPayloadValidationMetadataMl(prevState => ({
        ...prevState,
        papers_reference: prevState.papers_reference.filter((_, i) => i !== index),
      }));

    };

    const handleUrlInputChange = (e) => {
      setCurrentUrl(e.target.value);
    };
    
    const isValidUrlFormat = (url) => {
      try {
        new URL(url);
        return url.startsWith('http://') || url.startsWith('https://');
      } catch (error) {
        return false;
      }
    };
    
    const validateUrl = async () => {
      const url = currentUrl.trim();
      if (!url) {
        toast({
          title: t('toastMsg.metadataModal.urlIsMandatory'),
          position: 'top',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
        return;
      }
      if (!isValidUrlFormat(url)) {
        toast({
          title: t('toastMsg.metadataModal.invalidFormatUrl'),
          position: 'top',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
        return;
      }
      
      const urlList = payloadUploadMetadata.urlSito
        ? payloadUploadMetadata.urlSito.split(';').filter(item => item.trim() !== "")
        : [];
      
      if (urlList.includes(url)) {
        toast({
          title: t('toastMsg.metadataModal.existsUrl'),
          position: 'top',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
        return;
      }
      
      setIsValidating(true);
      
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        
        const checkUrl = async () => {
          try {
            const urlToCheck = new URL(url);
            urlToCheck.searchParams.append('_', Date.now());
            
            const response = await fetch(urlToCheck.toString(), { 
              method: 'HEAD',
              signal: controller.signal,
              mode: 'no-cors'
            });
            
            return { success: true };
          } catch (error) {
            if (error.name === 'AbortError') {
              return { success: false, message: 'Timeout - Il sito non risponde' };
            }
            return { success: false, message: error.message };
          } finally {
            clearTimeout(timeoutId);
          }
        };
        
        const result = await checkUrl();
        
        if (result.success) {
          const newUrlList = [...urlList, url];
          const newUrlSitoStr = newUrlList.join(";");
          
          setPayloadUploadMetadata(prev => ({
            ...prev,
            urlSito: newUrlSitoStr
          }));
          setCurrentUrl("");
          
          toast({
            title: t('toastMsg.metadataModal.urlSuccessfullyValidated'),
            status: 'success',
            position: "top",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: t('toastMsg.error'),
            description: t('toastMsg.metadataModal.urlIsInvalid'),
            position: 'top',
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
      } catch (error) {
        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.metadataModal.errorDuringValidation'),
          position: 'top',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      } finally {
        setIsValidating(false);
      }
    };
    
    const removeUrl = (urlToRemove) => {
      const urlList = payloadUploadMetadata.urlSito
        ? payloadUploadMetadata.urlSito.split(';').filter(item => item.trim() !== "")
        : [];
      const newUrlList = urlList.filter(url => url !== urlToRemove);
      const newUrlSitoStr = newUrlList.join(";");
      
      setPayloadUploadMetadata(prev => ({
        ...prev,
        urlSito: newUrlSitoStr
      }));
      toast({
        title: t('toastMsg.metadataModal.urlRemoved'),
        status: 'info',
        position: "top",
        duration: 2000,
        isClosable: true,
      });
    };  

  const handleUploadFile = () => {
    setIsModal1Open(false);
    setIsModal2Open(true);
  };
  const handleManualEntry = () => {
    setIsModal1Open(false);
    setIsModal3Open(true);
  };
  const handleAnnulla = () => {
    setPayloadUploadRequest(defaultPayloadUploadRequestValue)
    setIsModal1Open(true);
    setIsModal2Open(false);
    setIsModal3Open(false);

    setMetadataEntered(true);
    setIsInfoModalOpen(true);
    onClose();
  };
  const handleUploadSubmit = () => {
    if (payloadUploadRequest.file != null) {
      setIsConfirmModalOpen(true);
    } else {
      toast({
        title: t('toastMsg.error'),
        description: t('toastMsg.metadataModal.invalidFileOrFormat'),
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  };
  const handleConfirmUpload = async () => {
    setIsConfirmModalOpen(false);
    uploadFile();
    setMetadataEntered(false);
    setMetadataEnteredData([]);
    setPayloadUploadMetadata({ encoding: "utf8", visibility: "private" ,generatedByML: false});

    setIsModal1Open(false)
    setIsModal2Open(false);
    setIsModal3Open(false);
    onClose();
    fileSelectorRef.current.value = "";
  };

  const handleCancelUpload = () => {
    setIsConfirmModalOpen(false);
  };

  const DraggableItem = ({ id, text, content }) => {


    const [, drag] = useDrag(() => ({
      type: "ITEM",
      item: content,
    }));

    return (
      <Button ref={drag} bg="gray" color="white" borderWidth={1} >
        {text}
      </Button>
    );

  };


  // Droppable Component
  const DroppableArea = ({ onDrop, children }) => {


    const [{ isOver }, drop] = useDrop(() => ({
      accept: "ITEM",
      drop: (item) => {




        onDrop(
          item
        );
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }));

    return (

      <Box
        ref={drop} // Riferimento per il drop (drag-and-drop)
        borderWidth="2px" // Spessore del bordo
        borderStyle="solid" // Stile del bordo (può essere 'dashed', 'dotted', ecc.)
        borderColor="black" // Colore del bordo
        borderRadius="md" // Bordo arrotondato
        p={4} // Padding interno della box
        mb={3} // Margine inferiore
        h="100%" // Altezza della box
        bgColor={isOver ? "green.200" : "gray.200"} // Colore di sfondo condizionale
      >
        {children}
      </Box>
    );
  };





  const handleDropTag = (obj) => {

    // Update the tagsDropped state by adding the dropped tag
    setTagsDropped((prevTagDropped) => {
      const updatedDroppedTags = [...prevTagDropped, obj];

      handleChangePayloadUploadMetadata(updatedDroppedTags.map(tag => tag.tag_ID), "tags")
      // Sort the dropped tags alphabetically (assuming obj has a 'name' property)
      return updatedDroppedTags.sort((a, b) => a.tag_ID - b.tag_ID)
    });

    // Update the tags state by filtering out the dropped tag and sorting
    setTags((prevTag) => {
      const updatedTags = prevTag.filter((column) => column.tag_ID !== obj.tag_ID);

      // Sort the remaining tags alphabetically
      return updatedTags.sort((a, b) => a.tag_ID - b.tag_ID)
    });
  };

  function validateUrls(urlsString) {
    const urls = urlsString
      .split(";")
      .map((url) => url.trim())
      .filter((url) => url !== "");
    const urlRegex = /^(https?:\/\/[^\s]+)$/;
    return urls.length > 0 && urls.every((url) => urlRegex.test(url));
  }
  
  const handleUrlsChange = (value) => {
    handleChangePayloadUploadMetadata(value, "ds_source_urls");
  };
  //TEST MODIFICA handleOnClickConcludi

  const handleOnClickConcludi = async () => {



    console.log(payloadUploadMetadata)
    console.log(payloadValidationMetadataMl)
    setSpinnerLoading(true)
  
    const missingFields = [];

    if (!payloadUploadMetadata.description) {
      missingFields.push(t('catalog.stagingArea.metadataModal.description'));
    }
    if (!payloadUploadMetadata.urlSito) {
      missingFields.push(t('catalog.stagingArea.metadataModal.urlOfTheSiteOfOrigin'));
    }
    if (!payloadUploadMetadata.owner) {
      missingFields.push(t('catalog.stagingArea.metadataModal.owner'));
    }
    if (!payloadUploadMetadata.publisher) {
      missingFields.push(t('catalog.stagingArea.metadataModal.publisher'));
    }
    if (!payloadUploadMetadata.provider) {
      missingFields.push(t('catalog.stagingArea.metadataModal.provider'));
    }
    if (!payloadUploadMetadata.contactProvider) {
      missingFields.push(t('catalog.stagingArea.metadataModal.contact'));
    }
    if (!payloadUploadMetadata.creationDate) {
      missingFields.push(t('catalog.stagingArea.metadataModal.creationDate'));
    }
    if (!payloadUploadMetadata.languages || payloadUploadMetadata.languages.length === 0) {
      missingFields.push(t('catalog.stagingArea.metadataModal.datasetLanguages'));
    }
    if (!payloadUploadMetadata.frequenceUpdate) {
      missingFields.push(t('catalog.stagingArea.metadataModal.frequenceUpdate'));
    }
    if (!payloadUploadMetadata.encoding) {
      missingFields.push(t('catalog.stagingArea.metadataModal.encoding'));
    }
    if (!payloadUploadMetadata.dataThemes || payloadUploadMetadata.dataThemes.length === 0) {
      missingFields.push(t('catalog.stagingArea.metadataModal.datasetThemes'));
    }
    if (!payloadUploadMetadata.pnrrThemes || payloadUploadMetadata.pnrrThemes.length === 0) {
      missingFields.push(t('catalog.stagingArea.metadataModal.pnrrThemes'));
    }
    if (!payloadUploadMetadata.grinsThemes || payloadUploadMetadata.grinsThemes.length === 0) {
      missingFields.push(t('catalog.stagingArea.metadataModal.grinsThemes'));
    }
    if (!payloadUploadMetadata.licence_id) {
      missingFields.push(t('catalog.stagingArea.metadataModal.licences'));
    }
    if (!payloadUploadMetadata.tableId) {
      missingFields.push(t('catalog.stagingArea.metadataModal.tableName'));
    }
    if (!payloadUploadMetadata.ds_geographical_coverage) {
      missingFields.push(t('catalog.stagingArea.metadataModal.geographicalCoverages'));
    }
    if (!payloadUploadMetadata.ds_typology_source) {
      missingFields.push(t('catalog.stagingArea.metadataModal.sourceType'));
    }
    if (!payloadUploadMetadata.ds_level_aggregation) {
      missingFields.push(t('catalog.stagingArea.metadataModal.aggregationLevel'));
    }
    if (!payloadUploadMetadata.ds_record_identifier) {
      missingFields.push(t('catalog.stagingArea.metadataModal.recordIdentifier'));
    }
    if (payloadUploadMetadata.prov_elab && (!payloadUploadMetadata.type_elab || payloadUploadMetadata.type_elab.trim() === "")) {
      missingFields.push(t('catalog.stagingArea.metadataModal.insertDescription'));
    }
    if (payloadUploadMetadata.ext_proccesing) {
      if (
        !payloadUploadMetadata.ds_source_urls ||
        payloadUploadMetadata.ds_source_urls.trim() === "" ||
        !validateUrls(payloadUploadMetadata.ds_source_urls)
      ) {
        missingFields.push(t('catalog.stagingArea.metadataModal.urlsDatasetOrigin'));
        missingFields.push(t('toastMsg.metadataModal.datasetOriginUrlsError'));
      }
    }

    if (missingFields.length > 0) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.metadataModal.reqFields'),
        description: missingFields.join(', ') ,
        position: "top",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }


    if (
      (payloadUploadMetadata.newTagName != null && payloadUploadMetadata.newTagName.trim() !== "" &&
       (payloadUploadMetadata.newTagDescription == null || payloadUploadMetadata.newTagDescription.trim() === "")) ||
      (payloadUploadMetadata.newTagDescription != null && payloadUploadMetadata.newTagDescription.trim() !== "" &&
       (payloadUploadMetadata.newTagName == null || payloadUploadMetadata.newTagName.trim() === ""))
    ) {
      setSpinnerLoading(false);


      toast({
        title: t('toastMsg.metadataModal.reqFields'),
        description:t('toastMsg.metadataModal.newTagFieldsError'),
        position: "top",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      
      return
    }
  
    try {
      
      
      if(payloadUploadMetadata.generatedByML) {
        


        
        

       let res = await insertValidationMetadataMl(t,payloadValidationMetadataMl)
       
        if(res != null && res.id_validation_metadataml != null) {
          payloadUploadMetadata.id_validation_metadataml = res.id_validation_metadataml;
        }
      }


      console.log(payloadUploadMetadata)

      // Perform metadata upload
     await uploadMetadata(payloadUploadMetadata);





      // Reset modal states and close
      // setMetadataEntered(false);
      // setMetadataEnteredData([]);
      // setPayloadUploadMetadata({ encoding: "utf8", visibility: "private", generatedByML:false });
      // onClose(); // Close the modal
    } catch (error) {
      // Handle upload errors
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setSpinnerLoading(false);
    }
  };

  // const handleOnClickAnnulla = () => {
  //   // Reset states related to the modal
  //   setMetadataEntered(false);
  //   setMetadataEnteredData([]);
  //   setPayloadUploadMetadata({ encoding: "utf8", visibility: "private" });

  //   onClose();
  // };


  const uploadMetadata = async (payloadUploadMetadata) => {
    try {

      payloadUploadMetadata["dtm_manager"] = sessionStorage.getItem("username")

      let licence = licenses.find(licence => licence.value === payloadUploadMetadata.licence_id)

      if (licence && licence.id)
        payloadUploadMetadata.licence_id = licence.id.toString()

      payloadUploadMetadata.dataThemes = datasetThemes.filter(datasetTheme => payloadUploadMetadata.dataThemes.includes(datasetTheme.value)).map(datasetTheme => datasetTheme.id)
      payloadUploadMetadata.pnrrThemes = pnrrThemes.filter(pnrrTheme => payloadUploadMetadata.pnrrThemes.includes(pnrrTheme.value)).map(pnrrTheme => pnrrTheme.id)
      payloadUploadMetadata.grinsThemes = grinsThemes.filter(grinsTheme => payloadUploadMetadata.grinsThemes.includes(grinsTheme.value)).map(grinsTheme => grinsTheme.id)

      if (!payloadUploadMetadata.visibility)
        payloadUploadMetadata.visibility = 'private'

      if (!payloadUploadMetadata.prov_elab)
        payloadUploadMetadata.prov_elab = false

      if (!payloadUploadMetadata.ext_proccesing)
        payloadUploadMetadata.ext_proccesing = false

      const formData = new FormData();

      Object.keys(payloadUploadMetadata).forEach(payloadUploadRequestKey => {
        formData.append(payloadUploadRequestKey, payloadUploadMetadata[payloadUploadRequestKey]);
      })

     
      console.log(formData)
    const urlFetch = `${react_api}/stagingAreaResult/uploadMetadataADP`;
      const response = await axiosInstance.post(urlFetch, formData, {
        headers: {

          'Authorization': sessionStorage.getItem('token')
        }
      })

      if (response.data.status === HTTP_STATUS_CODES.OK) {

        toast({
          title: t('toastMsg.metadataModal.firstPartSaved'),
          description: "",
          position: "top",
          status: "info",
          duration: 4000,
          isClosable: true,
        });
        // onClose()
        // setMetadataEntered(true);
        
        setStep(2);
        getTableCol(content.id).then(res => {
          setMetadataEnteredData(res.columns);
        });
      }
      
      if (response.data.status !== HTTP_STATUS_CODES.OK) {
        toast({
          title: t('toastMsg.error'),
          description: t(`messageBE.${response.data.message}`),
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }
    }
    catch (error) {

      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return null;
    }
  }

  const handleChangePayloadUploadMetadata = (e, field) => {
    const value = e.target ? e.target.value : e;

    setPayloadUploadMetadata((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const handleRemoveKeyPayloadUploadMetadata = (key) => {
    setPayloadUploadMetadata(current => {      
      const copy = { ...current };      
      delete copy[key];      
      return copy;    
    });
  };



  const handleRemoveTag = (obj) => {

    setTagsDropped((prevTagsDropped) => {
      const updatedTagsDropped = prevTagsDropped.filter((tag) => tag.tag_ID !== obj.tag_ID);
      handleChangePayloadUploadMetadata(updatedTagsDropped.map(tag => tag.tag_ID), "tags")

      return updatedTagsDropped.sort((a, b) => a.tag_ID - b.tag_ID)
    });

    setTags((prevTags) => {
      const updatedTags = [...prevTags, obj];

      return updatedTags.sort((a, b) => a.tag_ID - b.tag_ID);
    });
  };




  const [datasetThemes, setDatasetThemes] = useState([])
  const [pnrrThemes, setPnrrThemes] = useState([])
  const [grinsThemes, setGrinsThemes] = useState([])

  const [datasetLangs, setDatasetLangs] = useState([])
  const [frequenzeDiAggiornamento, setFrequenzeDiAggiornamento] = useState([])
  const [licenses, setLicenses] = useState([])

  const [geographicalCoverages, setGeographicalCoverages] = useState([])
  const [dataFrequency, setDataFrequency] = useState([])
  const [sourceTypes, setSourceTypes] = useState([])
  const [aggregationLevels, setAggregationLevels] = useState([])


  const [encodings, setEncodings] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false);





  const [tags, setTags] = useState([]);




  const [tagsDropped, setTagsDropped] = useState([]);






  const [descriptionMetadataPayload, setDescriptionMetadataPayload] = useState({
    "allDescriptionsCompleted": false,
    "tableId": "",
    "cols": {

    }
  });

  const toast = useToast();
  const { clearSessionData } = useSession();
  const navigate = useNavigate();

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {
    logout(t, clearSessionData, navigate, toast, axiosInstance);
  });
  initSurveyService(t, toast,axiosInstance)
  const checkMetadata = async (id) => {
    try {
      const urlFetch = `${react_api}/stagingAreaResult/checkMetadataADP`;
      const response = await axiosInstance.post(urlFetch, { tableId: id }, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return null;
    }
  };

  const getTableCol = async (id) => {
    try {
      const urlFetch = `${react_api}/stagingAreaResult/getTableColADP`;
      const response = await axiosInstance.post(urlFetch, { tableId: id }, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return null;
    }
  };

  const getSystemTable = async () => {
    try {
      const urlFetch = `${react_api}/getSystemTablesADP`;
      const response = await axiosInstance(urlFetch)


      return response.data;
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return null;
    }
  };


  const getTags = async () => {
    try {
      const urlFetch = `${react_api}/getTagsADP`;
      const response = await axiosInstance(urlFetch)


      return response.data;
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return null;
    }
  };


  const handleChangeDescriptionMetadata = (event, item) => {

    let val = event.target.value;


    setDescriptionMetadataPayload(payloadUploadRequest => {
      // Creiamo una copia di cols
      const updatedCols = { ...payloadUploadRequest.cols };

      // Se il valore è vuoto, rimuoviamo la proprietà

      updatedCols[item.name] = val;




      return {
        ...payloadUploadRequest,
        tableId: content.id,
        cols: updatedCols
      };

    });

  }

  const handleClickInvia = async () => {
    
    // Ensure metadata and payload are valid
    if (!metadataEnteredData || !descriptionMetadataPayload?.cols) {
      toast({
        title: t('toastMsg.metadataModal.invalidData'),
        description: t('toastMsg.metadataModal.missingRequiredMetadata'),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const allKeysHaveValidValues = Object.values(descriptionMetadataPayload.cols).every(value => value !== null && value !== "");




    if (!allKeysHaveValidValues) {
      toast({
        title: t('toastMsg.metadataModal.missingMetadata'),
        description: t('toastMsg.metadataModal.someRequiredMetadataMissing'),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    try {
      // Show loading

      descriptionMetadataPayload.allDescriptionsCompleted = allKeysHaveValidValues;

      setDescriptionMetadataPayload(descriptionMetadataPayload)

      setIsSubmitting(true);



      const urlFetch = `${react_api}/stagingAreaResult/uploadColDescADP`;
      const response = await axiosInstance.post(urlFetch, descriptionMetadataPayload, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.data.status === HTTP_STATUS_CODES.OK) {
        toast({
          title: response.data.message,
          description: "",
          position: "top",
          status: "info",
          duration: 4000,
          isClosable: true,
        });
        onClose(); // Only close modal, no payload dependency
        removeStagingAreaItem(content.id);

      } 
      if (response.data.status !== HTTP_STATUS_CODES.OK) {
        toast({
          title: t('toastMsg.error'),
          description: t(`messageBE.${response.data.message}`),
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: error.response?.data?.message || String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      // Reset loading
      setIsSubmitting(false);
    }
  };

  const normalizeCols = (currentCols, previousCols) => {
    const normalized = {};

    for (const key in currentCols) {
      if (
        currentCols[key] !== "" ||
        (previousCols && previousCols[key] !== undefined && currentCols[key] !== previousCols[key])
      ) {
        if (!(savedEmptyColumns.has(key) && currentCols[key] === "")) {
          normalized[key] = currentCols[key];
        }
      }
    }

    return normalized;
  };

  const hasMetadataChangedDesc = () => {
    if (!previousMetadataPayload) {
      return true;
    }

    const normalizedCurrentCols = normalizeCols(descriptionMetadataPayload.cols, previousMetadataPayload.cols);
    const normalizedPreviousCols = normalizeCols(previousMetadataPayload.cols, previousMetadataPayload.cols);

    return JSON.stringify(normalizedPreviousCols) !== JSON.stringify(normalizedCurrentCols);
  };


  const handleClickSalva = async () => {
    if (!hasMetadataChangedDesc()) {
      console.log("Nessuna modifica rilevata. Passaggio alla pagina successiva senza salvare.");

      return;
    }
    try {

      const normalizedCols = normalizeCols(descriptionMetadataPayload.cols, previousMetadataPayload.cols);
      const body = {
        ...descriptionMetadataPayload,
        cols: normalizedCols,
        tableId: content.id,
        allDescriptionsCompleted: false,
      };
      // const allKeysHaveValidValues = Object.values(descriptionMetadataPayload.cols).every(
      //   (value) => value !== null && value !== ""
      // );



      // Create a shallow copy of the top-level object and deeply copy the cols property
      // let body = { ...descriptionMetadataPayload, cols: { ...descriptionMetadataPayload.cols } };

      // body.tableId = content.id;
      // body.allDescriptionsCompleted = false;

      // Modify the cols property in the copy
      // for (const key in body.cols) {
      //   if (body.cols[key] === "") {
      //     delete body.cols[key];
      //   }
      // }
      setIsSubmitting(true);
      if (!body.allDescriptionsCompleted) {
        const urlFetch = `${react_api}/stagingAreaResult/uploadColDescADP`;
        const response = await axiosInstance.post(urlFetch, body, {
          headers: { 'Content-Type': 'application/json' },
        });

        if (response.data.status === HTTP_STATUS_CODES.OK) {
          // setPreviousMetadataPayload({ ...body, cols: body.cols });

          // Aggiorna lo stato delle colonne già salvate come vuote
          const newlyEmptyCols = Object.keys(normalizedCols).filter((key) => normalizedCols[key] === "");
          setSavedEmptyColumns((prev) => new Set([...prev, ...newlyEmptyCols]));

          setPreviousMetadataPayload({ ...body, cols: normalizedCols });
        } 
        if (response.data.status !== HTTP_STATUS_CODES.OK) {
          toast({
            title: t('toastMsg.error'),
            description: t(`messageBE.${response.data.message}`),
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }

      }

    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: error.response?.data?.message || String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(metadataEnteredData.length / itemsPage)) {
      setCurrentPage((prev) => prev + 1);
      handleClickSalva();
    }
  };

  const handlePreviousPage = () => {


    if (currentPage === Math.ceil(metadataEnteredData.length / itemsPage)) {
      // Sei sull'ultima pagina, aggiorna le colonne
      const updatedData = metadataEnteredData.map((item, index) => {
        if (index >= (currentPage - 1) * itemsPage) {
          return { ...item, name: "" }; // Sostituisci le colonne con ""
        }
        return item; // Lascia gli altri oggetti invariati
      });

      
    }


    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const uploadFile = async () => {

    if (payloadUploadRequest.file != null) {
      try {
        setSpinnerLoading(true)

        const formData = new FormData();
        formData.append("username", sessionStorage.getItem("username"));
        formData.append("file", payloadUploadRequest.file);
        formData.append("tableId", content.id);
        // Object.keys(payloadUploadRequest).forEach(payloadUploadRequestKey => {
        //   formData.append(payloadUploadRequestKey, payloadUploadRequest[payloadUploadRequestKey]);
        // });
        const options = {
          headers: {
            "Authorization": sessionStorage.getItem("token"),
          },
        };
        const response = await axiosInstance.post(`${react_api}/stagingAreaResult/uploadColDescCsvADP`, formData, options);

        const result = response.data;

        if (result.status === HTTP_STATUS_CODES.OK) {
          setPayloadUploadRequest(defaultPayloadUploadRequestValue);
          

          setSpinnerLoading(false)

          toast({
            title: t('toastMsg.metadataModal.uploadCompleted'),
            description: "",
            status: 'success',
            duration: 4000,
            isClosable: true
          });

          removeStagingAreaItem(content.id);
        } 

        if (result.status !== HTTP_STATUS_CODES.OK) {
          handleAnnulla();
          setSpinnerLoading(false);
          toast({
            title: t('toastMsg.error'),
            description: t('toastMsg.metadataModal.uploadError'),
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
      } catch (error) {
        handleAnnulla();
        setSpinnerLoading(false)

        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.metadataModal.uploadGenericError'),
          status: 'error',
          duration: 4000,
          isClosable: true
        });

      }
    } else {
      toast({
        title: t('toastMsg.error'),
        description: t('toastMsg.metadataModal.invalidFileOrFormat'),
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      setIsModal2Open(true);

      return;
    }

  };


  const handleChangePayloadRequest = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (!file.name.endsWith(".csv")) {
        event.target.value = "";
        setPayloadUploadRequest({ file: null });
        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.metadataModal.invalidFileOrFormat'),
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      if (hasAccents(file.name)) {
        event.target.value = "";
        setPayloadUploadRequest({ file: null });
        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.metadataModal.fileNameCannotContainAccents'),
          status: 'warning',
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      setPayloadUploadRequest({ file });
    }
  };

  useEffect(() => {

    getSystemTable().then(res => {
      setGrinsThemes([]);
      setPnrrThemes([]);
      setDatasetThemes([])
      setDatasetLangs([])
      setFrequenzeDiAggiornamento([])
      setLicenses([])
      setGeographicalCoverages([])
      setDataFrequency([])
      setAggregationLevels([])
      setSourceTypes([])
      setEncodings([])
      setCurrentUrl("");

      const datasetLang = res.tables_info.find(tblInfo => tblInfo.name === "Lingue del dataset");
      const frequenzeDiAggiornamento = res.tables_info.find(tblInfo => tblInfo.name === "Frequenza di aggiornamento");
      const encodings = res.tables_info.find(tblInfo => tblInfo.name === "Encoding");

      const datasetTheme = res.tables_info.find(tblInfo => tblInfo.name === "Temi dei dataset");
      const pnrrTheme = res.tables_info.find(tblInfo => tblInfo.name === "PNNR_Themes");
      const grinsTheme = res.tables_info.find(tblInfo => tblInfo.name === "GRINS_Themes");

      const licenses = res.tables_info.find(tblInfo => tblInfo.name === "Licenze");
      const geographicalCoverages = res.tables_info.find(tblInfo => tblInfo.name === "Geographical coverage");
      const dataFrequency = res.tables_info.find(tblInfo => tblInfo.name === "Data frequency");
      const sourceTypes = res.tables_info.find(tblInfo => tblInfo.name === "Source type");

      const aggregationLevels = res.tables_info.find(tblInfo => tblInfo.name === "Aggregation level");

      if (datasetLang && datasetLang.values) {
        // Generate new themes with IDs
        const newLang = datasetLang.values.map((data, index) => ({
          id: index + 1 + datasetLang.length, // Dynamically set ID
          value: data
        }));

        // Update the state with new themes
        setDatasetLangs(prevState => [
          ...prevState,
          ...newLang
        ]);
      }

      if (frequenzeDiAggiornamento && frequenzeDiAggiornamento.values) {
        // Generate new themes with IDs
        const newFrequenzaAggiornamento = frequenzeDiAggiornamento.values.map((data, index) => ({
          id: index + 1 + frequenzeDiAggiornamento.length, // Dynamically set ID
          value: data
        }));

        // Update the state with new themes
        setFrequenzeDiAggiornamento(prevState => [
          ...prevState,
          ...newFrequenzaAggiornamento
        ]);
      }


      if (encodings && encodings.values) {
        // Generate new themes with IDs
        const newEncoding = encodings.values.map((data, index) => ({
          id: index + 1 + encodings.length, // Dynamically set ID
          value: data
        }));

        // Update the state with new themes
        setEncodings(prevState => [
          ...prevState,
          ...newEncoding
        ]);
      }


      if (datasetTheme && datasetTheme.values) {
        // Generate new themes with IDs
        const newThemes = datasetTheme.values.map((data, index) => ({
          id: index + 1, // Dynamically set ID
          value: data
        }));

        // Update the state with new themes
        setDatasetThemes(prevState => [
          ...prevState,
          ...newThemes
        ]);
      }
      if (pnrrTheme && pnrrTheme.values) {
        // Generate new themes with IDs
        const newThemes = pnrrTheme.values.map((data, index) => ({
          id: index + 1, // Dynamically set ID
          value: data
        }));

        // Update the state with new themes
        setPnrrThemes(prevState => [
          ...prevState,
          ...newThemes
        ]);
      }



      if (grinsTheme && grinsTheme.values) {
        // Generate new themes with IDs
        const newThemes = grinsTheme.values.map((data, index) => ({
          id: index + 1, // Dynamically set ID
          value: data
        }));


        // Update the state with new themes
        setGrinsThemes(prevState => [
          ...prevState,
          ...newThemes
        ]);
        
        
      }






      if (licenses && licenses.values) {
        // Update the state with new licenses
        setLicenses(prevState => {
          // Generate new licenses with dynamically set IDs based on prevState length
          const newLicense = licenses.values.map((data, index) => ({
            id: index + 1 + prevState.length, // Dynamically set ID based on previous length
            value: data
          }));

          return [
            ...prevState,
            ...newLicense
          ];
        });
      }

      
      if (geographicalCoverages && geographicalCoverages.values) {
        // Update the state with new licenses
        setGeographicalCoverages(prevState => {
          // Generate new licenses with dynamically set IDs based on prevState length
          const newGraphicalCoverage = geographicalCoverages.values.map((data, index) => ({
            id: index + 1 + prevState.length, // Dynamically set ID based on previous length
            value: data
          }));

          return [
            ...prevState,
            ...newGraphicalCoverage
          ];
        });
      }

      if (dataFrequency && dataFrequency.values) {
        // Update the state with new licenses
        setDataFrequency(prevState => {
          // Generate new licenses with dynamically set IDs based on prevState length
          const newDataFrequency = dataFrequency.values.map((data, index) => ({
            id: index + 1 + prevState.length, // Dynamically set ID based on previous length
            value: data
          }));

          return [
            ...prevState,
            ...newDataFrequency
          ];
        });
      }


      if (sourceTypes && sourceTypes.values) {
        // Update the state with new licenses
        setSourceTypes(prevState => {
          // Generate new licenses with dynamically set IDs based on prevState length
          const newSourceTypes = sourceTypes.values.map((data, index) => ({
            id: index + 1 + prevState.length, // Dynamically set ID based on previous length
            value: data
          }));

          return [
            ...prevState,
            ...newSourceTypes
          ];
        });
      }


      if (aggregationLevels && aggregationLevels.values) {
        // Update the state with new licenses
        setAggregationLevels(prevState => {
          // Generate new licenses with dynamically set IDs based on prevState length
          const newAggregationLevels = aggregationLevels.values.map((data, index) => ({
            id: index + 1 + prevState.length, // Dynamically set ID based on previous length
            value: data
          }));

          return [
            ...prevState,
            ...newAggregationLevels
          ];
        });
      }








    })




    if (isOpen && content != null && content.id != null) {
      setStep(null);
      setPage(1)
      setMaxNumberPage(7)
      setPayloadUploadMetadata({ encoding: "utf8", visibility: "private", generatedByML: false })
      setMetadataEnteredData([])
      setDescriptionMetadataPayload({})
      setPreviousMetadataPayload({})

      setTagsDropped([])
      checkMetadata(content.id).then(res => {
        if (res != null && res.metadataEntered === 'true') {
          setMetadataEntered(true);

          getTableCol(content.id).then(res => {
            setMetadataEnteredData(res.columns);
            // Popola lo stato con i valori iniziali
            const initialCols = res.columns.reduce((acc, column) => {
              // acc[column.name] = column.fielddescription || ""; // Usa un valore di default se necessario
              acc[column.name] = column.fielddescription === "descrizione mancante" ? "" : column.fielddescription || "";
              return acc;
            }, {});
            setDescriptionMetadataPayload(prev => ({
              ...prev,
              cols: initialCols,
            }));
            setPreviousMetadataPayload(prev => ({
              ...prev,
              cols: initialCols,
            }));
          });
          setStep(2);

        } else {
          setMetadataEntered(false);
          setStep(1);
        }
      });
    }

    getTags().then(res => {
      setTags(res.tags)

    })

  }, [isOpen, content]); // Run effect on isOpen or content changes

  return (
    <DndProvider backend={HTML5Backend}>





      {spinnerLoading && (
        <SpinnerXL />
      )}
      {step === 1 ? (
        <Modal isOpen={isOpen} onClose={() => { onClose(); setStep(null); setMetadataEntered(true); }} size="xl" closeOnOverlayClick={false}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t('catalog.stagingArea.metadataModal.publishingMetadata')}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {/* Pagina 1 */}
              {page === 1 && (
                <>
                  <FormControl mb={4}>
                    <FormLabel>{t('catalog.stagingArea.metadataModal.tableName')}</FormLabel>
                    {content && content.tableName ? (
                      <p>{content.tableName}</p>
                    ) : null}
                  </FormControl>

                  <FormControl mb={4} >
                    <FormLabel>{t('catalog.stagingArea.metadataModal.idOfTheDatasetsFromWhichItDerivesSeparatedBy')} ;</FormLabel>
                    <Input required value={payloadUploadMetadata["versionOf"]} placeholder="es: 0AAA19;0AAB99;0AAB54" onChange={(e) => handleChangePayloadUploadMetadata(e, 'versionOf')} />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>{t('catalog.stagingArea.metadataModal.typology')}</FormLabel>
                    <RadioGroup defaultValue="private" value={payloadUploadMetadata.visibility} onChange={(e) => handleChangePayloadUploadMetadata(e, 'visibility')}>
                      <Stack direction="row">
                        <Radio value="public">{t('catalog.stagingArea.metadataModal.public')}</Radio>
                        <Radio value="private">{t('catalog.stagingArea.metadataModal.private')}</Radio>
                      </Stack>
                    </RadioGroup>
                  </FormControl>

                  
                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.recordIdentifier')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Record Identifier:</Text></PopoverHeader>
                                <PopoverBody>Describe identifiers of unique record for dataset. (e.g. municipality-yea; financial transaction identifer; province monthly.)</PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input placeholder={t('catalog.stagingArea.metadataModal.insertRecordIdentifier')} required value={payloadUploadMetadata.ds_record_identifier} onChange={(e) => handleChangePayloadUploadMetadata(e, 'ds_record_identifier')} />
                  </FormControl>
                  
                  
                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.description')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Description:</Text></PopoverHeader>
                                <PopoverBody>Description of the main contents of the data set. Where possible, provide guidance on the structure of the data that make up the data set (Avoid using language that is rich in normative references. Instead, use simple language that can help any user identify the contents of the data set)</PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Textarea required placeholder={t('catalog.stagingArea.metadataModal.insertDescription')} value={payloadUploadMetadata.description} onChange={(e) => handleChangePayloadUploadMetadata(e, 'description')} />
                  </FormControl>
                </>
              )}
              {/* Pagina 2 */}
              {page === 2 && (
                <>

                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.urlOfTheSiteOfOrigin')}</FormLabel>
                      <Popover placement="top">
                        <PopoverTrigger>
                            <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                <MdInfo size={20} />
                            </Button>
                        </PopoverTrigger>
                          <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Url of the site of origin:</Text></PopoverHeader>
                              <PopoverBody>It is a link to a web page that provides access to the data set or a distribution of it or additional information. The page must be the data set provider's source page; the URL of a web page referable to a site provided by a third party, as in the case of an aggregator, is not valid.</PopoverBody>
                          </PopoverContent>
                      </Popover>
                    </Flex>
                    <InputGroup>
                      <Input 
                        placeholder={t('catalog.stagingArea.metadataModal.insertUrl')} 
                        value={currentUrl} 
                        onChange={handleUrlInputChange}
                      />
                      <InputRightElement width="4.5rem">
                        <Button 
                          h="1.75rem" 
                          size="sm" 
                          colorScheme="teal"
                          isLoading={isValidating}
                          onClick={validateUrl}
                        >
                          {t('catalog.stagingArea.metadataModal.add')}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                  </FormControl>
                  {payloadUploadMetadata.urlSito && payloadUploadMetadata.urlSito.split(';').filter(item => item.trim() !== "").length > 0 && (
                    <Box mt={2} mb={4}>
                      <VStack align="stretch" spacing={2}>
                        {payloadUploadMetadata.urlSito
                          .split(';')
                          .filter(item => item.trim() !== "")
                          .map((url, index) => (
                            <Box key={index} p={2} borderWidth="1px" borderRadius="md" borderColor="green.200" bg="green.50">
                              <HStack justify="space-between">
                                <HStack>
                                  <MdCheckCircle color="green" />
                                  <Text fontSize="sm" noOfLines={1} maxWidth="300px">
                                    {url}
                                  </Text>
                                </HStack>
                                <HStack>
                                  <Button 
                                    size="xs" 
                                    variant="ghost" 
                                    colorScheme="blue" 
                                    leftIcon={<FaExternalLinkAlt />} 
                                    onClick={() => window.open(url, '_blank')}
                                  >
                                    {t('catalog.stagingArea.metadataModal.open')}
                                  </Button>
                                  <Button 
                                    size="xs"
                                    variant="ghost"
                                    colorScheme="red"
                                    leftIcon={<MdDelete />}
                                    onClick={() => removeUrl(url)}
                                  >
                                    {t('catalog.stagingArea.metadataModal.remove')}
                                  </Button>
                                </HStack>
                              </HStack>
                            </Box>
                          ))
                        }
                      </VStack>
                    </Box>
                  )}
                  <FormControl mb={4}>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.otherIdentifier')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Other identifier:</Text></PopoverHeader>
                                <PopoverBody>It is one or more secondary identifiers for the data set. For example, the data set identifier retrieved from the system from which the data set is extracted.</PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input placeholder={t('catalog.stagingArea.metadataModal.insertId')} required value={payloadUploadMetadata.otherId} onChange={(e) => handleChangePayloadUploadMetadata(e, 'otherId')} />
                  </FormControl>
                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.owner')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Owner:</Text></PopoverHeader>
                                <PopoverBody>
                                It is the organization (or public administration) that holds ownership of the data and is therefore responsible for the overall management of the data set. 
                                (It is recommended that names of individual persons be avoided. The name and identification code of the organization should be entered)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input placeholder={t('catalog.stagingArea.metadataModal.enterHoldersName')} required value={payloadUploadMetadata.owner} onChange={(e) => handleChangePayloadUploadMetadata(e, 'owner')} />
                  </FormControl>
                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.publisher')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Publisher:</Text></PopoverHeader>
                                <PopoverBody>
                                The organization (or public administration) that makes the data set available by publishing it. 
                                (Both the name and identification code of the organization should be given. Do not include names of individual persons.)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input placeholder={t('catalog.stagingArea.metadataModal.datasetPublisher')} required value={payloadUploadMetadata.publisher} onChange={(e) => handleChangePayloadUploadMetadata(e, 'publisher')} />
                  </FormControl>
                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.provider')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Provider:</Text></PopoverHeader>
                                <PopoverBody>
                                This property refers to one or more entities (organization) that materially created the data set. If the publisher did not produce it, the organization (or public administration) that materially produced the data set may be referred to as the provider.  
                                (It is recommended that names of individuals be avoided. The name of the organization and its identification code should be entered.)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input placeholder={t('catalog.stagingArea.metadataModal.creatorsName')} required value={payloadUploadMetadata.provider} onChange={(e) => handleChangePayloadUploadMetadata(e, 'provider')} />
                  </FormControl>
                </>
              )}
              {/* Pagina 3 */}
              {page === 3 && (
                <>




                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.contact')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Contact:</Text></PopoverHeader>
                                <PopoverBody>Specify contact information (typically an e-mail address) used to send comments, inquiries, and inquiries about the data set. It is best not to confuse this metadata with the organization that owns or publishes or creates the data set. The point of contact is used to specify references to an office in the organization that can provide information about the data set.</PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input placeholder={t('catalog.stagingArea.metadataModal.insertEmailContact')} required value={payloadUploadMetadata.contactProvider} onChange={(e) => handleChangePayloadUploadMetadata(e, 'contactProvider')} />
                  </FormControl>
                  <FormControl mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel>{t('catalog.stagingArea.metadataModal.creationDate')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Creation Date:</Text></PopoverHeader>
                                <PopoverBody>If the data set was created prior to publication, it is possible to indicate, if the information is relevant, the date on which it was created.</PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input type="date" required value={payloadUploadMetadata.creationDate} onChange={(e) => handleChangePayloadUploadMetadata(e, 'creationDate')} />
                  </FormControl>
                  <Flex align="center">
                    <FormLabel>{t('catalog.stagingArea.metadataModal.timeCoverage')}</FormLabel>
                    <Popover placement="top">
                        <PopoverTrigger>
                            <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                <MdInfo size={20} />
                            </Button>
                        </PopoverTrigger>
                          <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Time coverage:</Text></PopoverHeader>
                              <PopoverBody>Enter, if applicable, the start and end date of the period to which the data set data refer.</PopoverBody>
                          </PopoverContent>
                    </Popover>
                  </Flex>
                  <FormControl mb={4}>
                    <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.startDate')}</FormLabel>
                    <Input type="date" value={payloadUploadMetadata.startDate} onChange={(e) => handleChangePayloadUploadMetadata(e, 'startDate')} />
                  </FormControl>

                  <FormControl mb={4}>
                    <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.endDate')}</FormLabel>
                    <Input type="date" value={payloadUploadMetadata.endDate} onChange={(e) => handleChangePayloadUploadMetadata(e, 'endDate')} />
                  </FormControl>

                  <Flex align="center">
                    <FormLabel>{t('catalog.stagingArea.metadataModal.datasetLanguages')}<Box as="span" ml={2} color={"red"}>*</Box></FormLabel>
                    <Popover placement="top">
                        <PopoverTrigger>
                            <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                <MdInfo size={20} />
                            </Button>
                        </PopoverTrigger>
                          <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Dataset Languages:</Text></PopoverHeader>
                              <PopoverBody>
                                Indicate one or more languages used in the data set
                                (The code list for the 24 official EU languages, to be used to enhance the element, is based on the three-letter codes of ISO 639-2/B as defined at http://www.loc.gov/standards/iso639-2/)
                              </PopoverBody>
                          </PopoverContent>
                    </Popover>
                  </Flex>
                  <CheckboxGroup defaultValue={payloadUploadMetadata.languages} onChange={(e) => { handleChangePayloadUploadMetadata(e, 'languages') }}>
                    <Stack spacing={4} direction="row">
                      <Checkbox value="Italiano"  >{t('catalog.stagingArea.metadataModal.italian')}</Checkbox>
                      <Checkbox value="Inglese" >{t('catalog.stagingArea.metadataModal.english')}</Checkbox>
                      <Checkbox value="Tedesco" >{t('catalog.stagingArea.metadataModal.german')}</Checkbox>
                    </Stack>
                  </CheckboxGroup>


                </>
              )}

              {/* Pagina 4 */}
              {page === 4 && (
                <>
                  <FormControl as="fieldset" mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel as="legend">{t('catalog.stagingArea.metadataModal.frequenceUpdate')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Frequence Update:</Text></PopoverHeader>
                                <PopoverBody>
                                  Temporal frequency with which the data set is updated
                                  (Proposals referring to the European vocabulary on frequencies could be considered, such as: continuously updated, quarterly, monthly, weekly, daily, never,…)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <RadioGroup
                      value={payloadUploadMetadata.frequenceUpdate}
                      onChange={(value) => {

                        handleChangePayloadUploadMetadata(value, 'frequenceUpdate'); // Aggiorna il payload
                      }}
                      spacing={4}
                      direction={"row"}
                    >
                      <VStack align="start">
                        {frequenzeDiAggiornamento.map((frequenzaAggiornamento, index) => (
                          <Radio key={index} value={frequenzaAggiornamento.value}>
                            {frequenzaAggiornamento.value}
                          </Radio>
                        ))}
                      </VStack>
                    </RadioGroup>
                  </FormControl>


                  <FormControl as="fieldset" mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel as="legend">{t('catalog.stagingArea.metadataModal.encoding')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Encoding:</Text></PopoverHeader>
                                <PopoverBody>
                                  This property refers to the encoding of alphabetic characters for writing the data set distribution.
                                  (Conventionally, the 'UTF-8' encoding has been chosen so that even languages with alphabetic characters other than Italian can be represented correctly.)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <RadioGroup
                      value={payloadUploadMetadata.encoding}
                      defaultValue={encodings[0].value}
                      onChange={(value) => {

                        handleChangePayloadUploadMetadata(value, 'encoding'); // Aggiorna il payload
                      }}
                    >
                      <VStack align="start">
                        {encodings.map((encoding, index) => (
                          <Radio key={index} value={encoding.value}>
                            {encoding.value}
                          </Radio>
                        ))}
                      </VStack>
                    </RadioGroup>
                  </FormControl>


                  <Flex align="center">
                    <FormLabel as="legend">{t('catalog.stagingArea.metadataModal.datasetThemes')}<Box as="span" ml={2} color={"red"}>*</Box></FormLabel>
                    <Popover placement="top">
                        <PopoverTrigger>
                            <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                <MdInfo size={20} />
                            </Button>
                        </PopoverTrigger>
                          <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Dataset Themes:</Text></PopoverHeader>
                              <PopoverBody>
                                Assign the data set one or more themes describing the domain in which it is located, choosing from those proposed in the drop-down menu. The proposed themes are those defined in the European Vocabulary on Themes for catalogs containing data sets
                                (Consider the 13 proposed themes indicated in 3.2.3)
                              </PopoverBody>
                          </PopoverContent>
                    </Popover>
                  </Flex>
                  <CheckboxGroup value={payloadUploadMetadata.dataThemes} onChange={(e) => handleChangePayloadUploadMetadata(e, 'dataThemes')}>
                    <VStack align="start">
                      {datasetThemes.map((theme, index) => (
                        <Checkbox key={index} value={theme.value}>
                          {theme.value}
                        </Checkbox>
                      ))}
                    </VStack>
                  </CheckboxGroup>
                </>
              )}
              {/* Pagina 5 */}
              {page === 5 && (
                <>

                  <FormControl as="fieldset" mb={4} isRequired>


                <FormLabel mt={4} as="legend">{t('catalog.stagingArea.metadataModal.pnrrThemes')}</FormLabel>
                  <CheckboxGroup value={payloadUploadMetadata.pnrrThemes} onChange={(e) => handleChangePayloadUploadMetadata(e, 'pnrrThemes')}>
                    <VStack align="start">
                      {pnrrThemes.map((theme, index) => (
                        <Checkbox key={index} value={theme.value}>
                          {theme.value}
                        </Checkbox>
                      ))}
                    </VStack>
                  </CheckboxGroup>


                  <FormLabel mt={4} as="legend">{t('catalog.stagingArea.metadataModal.grinsThemes')}</FormLabel>
                  <CheckboxGroup mb={3} value={payloadUploadMetadata.grinsThemes} onChange={(e) => handleChangePayloadUploadMetadata(e, 'grinsThemes')}>
                    <VStack align="start">
                      {grinsThemes.map((theme, index) => (
                        <Checkbox key={index} value={theme.value}>
                          {theme.value}
                        </Checkbox>
                      ))}
                    </VStack>
                  </CheckboxGroup>
                      </FormControl>
                      <Flex align="center">
                    <FormLabel  mt={3} as="legend">{t('catalog.stagingArea.metadataModal.licences')}</FormLabel>
                    <Popover placement="top">
                        <PopoverTrigger>
                            <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                <MdInfo size={20} />
                            </Button>
                        </PopoverTrigger>
                          <PopoverContent minW="500px">
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Licences :</Text></PopoverHeader>
                              <PopoverBody>
                                This property refers to the license under which the data set is published. (
                                <Link
                                  href="https://creativecommons.it/chapterIT/index.php/license-your-work/"
                                  isExternal
                                  color="teal.500"
                                  ml={1}
                                >
                                  https://creativecommons.it/chapterIT/index.php/license-your-work/
                                </Link>
                                )
                              </PopoverBody>
                          </PopoverContent>
                    </Popover>
                  </Flex>

      <Accordion allowToggle mt={4}>
        {licenses.map((licence, index) => {
          // Se il valore è "Altro", non mostrare l'Accordion, ma un semplice radio button
          if (licence.value === "Altro") {
            return (
              <Box key={index} display="flex" alignItems="center" p={2}>
                <Radio
                  value={licence.value}
                  isChecked={payloadUploadMetadata.licence_id === licence.value}
                  onChange={() => {
                    handleChangePayloadUploadMetadata(licence.value, 'licence_id');
                    setPayloadUploadMetadata((prevMetadata) => ({
                      ...prevMetadata,
                      tableId: content.id,
                      encoding: prevMetadata.encoding || encodings[0].value,
                    }));
                  }}
                  mr={4}
                />
                <Box>{licence.value}</Box>
              </Box>
            );
          }

          return (
            <AccordionItem key={index}>
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton>
                      <Radio
                        value={licence.value}
                        isChecked={payloadUploadMetadata.licence_id === licence.value}
                        onChange={() => {
                          handleChangePayloadUploadMetadata(licence.value, 'licence_id');
                          setPayloadUploadMetadata((prevMetadata) => ({
                            ...prevMetadata,
                            tableId: content.id,
                            encoding: prevMetadata.encoding || encodings[0].value,
                          }));
                        }}
                        mr={4}
                      />
                      <Box flex="1" textAlign="left">
                        {licence.value}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    {licenseDescriptions[licence.value] || "Descrizione non disponibile."}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          );
        })}
      </Accordion>




                </>
              )}



{page === 6 && (
                <>

                  <FormControl as="fieldset" mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel  mt={3} as="legend">{t('catalog.stagingArea.metadataModal.geographicalCoverages')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Geographical Coverages :</Text></PopoverHeader>
                                <PopoverBody>
                                  It is the geographical area covered by the data set; choose from the proposed ones, which refer to the "European table of places." 
                                  (enter the level that is present in http://www.geonames.org/)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>

                    <RadioGroup
                      value={payloadUploadMetadata.ds_geographical_coverage}
                      onChange={(value) => {

                        handleChangePayloadUploadMetadata(value, 'ds_geographical_coverage'); // Aggiorna il payload
                        setPayloadUploadMetadata((prevMetadata) => ({
                          ...prevMetadata,
                          tableId: content.id,
                          encoding: prevMetadata.encoding || encodings[0].value,
                        }));
                      }}
                    >
                      <VStack align="start">
                        {geographicalCoverages.map((geographicalCoverage, index) => (
                          <Radio key={index} value={geographicalCoverage.value}>
                            {geographicalCoverage.value}
                          </Radio>
                        ))}
                      </VStack>
                    </RadioGroup>
                  </FormControl>



                  <FormControl mb={4}>
                    <Flex align="center">
                      <FormLabel mt={3}>
                        {t('catalog.stagingArea.metadataModal.dataFrequency')}
                      </FormLabel>
                      <Popover placement="top">
                        <PopoverTrigger>
                          <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                            <MdInfo size={20} />
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent>
                          <PopoverArrow />
                          <PopoverCloseButton />
                          <PopoverHeader>
                            <Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">
                              Data Frequency :
                            </Text>
                          </PopoverHeader>
                          <PopoverBody>
                            Data Frequency of the Dataset (Yearly, Quarterly, Monthly, Weekly, Daily, Intra-day)
                          </PopoverBody>
                        </PopoverContent>
                      </Popover>
                    </Flex>
                    <Select
                      placeholder="Select"
                      value={payloadUploadMetadata.ds_data_frequency}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (selectedValue === "") {
                          handleRemoveKeyPayloadUploadMetadata('ds_data_frequency');
                        } else {
                          handleChangePayloadUploadMetadata(e, 'ds_data_frequency');
                          setPayloadUploadMetadata((prevMetadata) => ({
                            ...prevMetadata,
                            tableId: content.id,
                            encoding: prevMetadata.encoding || encodings[0].value,
                          }));
                        }
                      }}
                    >
                      {dataFrequency.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.value}
                        </option>
                      ))}
                    </Select>
                  </FormControl>




<FormControl as="fieldset" mb={4} isRequired>


<FormLabel  mt={3} as="legend">{t('catalog.stagingArea.metadataModal.sourceType')}</FormLabel>
<RadioGroup
  value={payloadUploadMetadata.ds_typology_source}
  onChange={(value) => {

    handleChangePayloadUploadMetadata(value, 'ds_typology_source'); // Aggiorna il payload
    setPayloadUploadMetadata((prevMetadata) => ({
      ...prevMetadata,
      tableId: content.id,
      encoding: prevMetadata.encoding || encodings[0].value,
    }));
  }}
>
  <VStack align="start">
    {sourceTypes.map((sourceType, index) => (
      <Radio key={index} value={sourceType.value}>
        {sourceType.value}
      </Radio>
    ))}
  </VStack>
</RadioGroup>
</FormControl>



<FormControl as="fieldset" mb={4} isRequired>


<FormLabel  mt={3} as="legend">{t('catalog.stagingArea.metadataModal.aggregationLevel')}</FormLabel>
<RadioGroup
  value={payloadUploadMetadata.ds_level_aggregation}
  onChange={(value) => {

    handleChangePayloadUploadMetadata(value, 'ds_level_aggregation'); // Aggiorna il payload
    setPayloadUploadMetadata((prevMetadata) => ({
      ...prevMetadata,
      tableId: content.id,
      encoding: prevMetadata.encoding || encodings[0].value,
    }));
  }}
>
  <VStack align="start">
    {aggregationLevels.map((sourceType, index) => (
      <Radio key={index} value={sourceType.value}>
        {sourceType.value}
      </Radio>
    ))}
  </VStack>
</RadioGroup>
</FormControl>


                </>
              )}


              {/* Pagina 5 */}
              {page === 7 && (
                <>
                  <Flex align="center">
                  <FormLabel as="legend">{t('catalog.stagingArea.metadataModal.selectTheMostAppropriateTagsForYourDataset')}:</FormLabel>
                    <Popover placement="top">
                        <PopoverTrigger>
                            <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                <MdInfo size={20} />
                            </Button>
                        </PopoverTrigger>
                          <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Select the most appropriate tags for your dataset :</Text></PopoverHeader>
                              <PopoverBody>
                                Enter one or more keywords that help identify the main object of the data set, making sure that they align with the theme used for the data set.
                              </PopoverBody>
                          </PopoverContent>
                    </Popover>
                  </Flex>
                  <Box id="sub_operations_content" mt={2}>
                    {tags.length > 0 &&
                      tags.map((item) => (
                        <DraggableItem
                          key={item.tag_ID}
                          id={item.tag_ID}
                          text={item.tag_name}
                          content={item}
                        />
                      ))}

                  </Box>


                  <DroppableArea
                    id="selected_tag"
                    onDrop={handleDropTag}

                  >

                    {tagsDropped.map((item, index) => (
                      <Button
                        key={index}
                        bg="gray" color="white" borderWidth={1}
                      >
                        {item.tag_name}
                        <Icon
                          as={MdDelete} // Change this to the icon you want
                          boxSize={5}
                          // Add click handler
                          onClick={() => handleRemoveTag(item)}
                          cursor="pointer"
                          ml={2} // Margin left to space the icon from the text
                        />
                      </Button>
                    ))}
                  </DroppableArea>


                  <FormLabel>{t('catalog.stagingArea.metadataModal.insertANewTag')}:</FormLabel>


                  <FormControl as="fieldset" mb={4} >
                  <Flex align="center">
                    <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.tagName')}:</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Tag name :</Text></PopoverHeader>
                                <PopoverBody>
                                  It is recommended to choose words carefully and to try, as much as possible, to use words already used within the catalog.
                                  (Certain characters such as comma, apostrophe, "/" and other non-alphanumeric characters are not allowed in the definition of keywords. Therefore, keywords such as "air quality control" or "disused quarries, quarries" or "law 190/2012" are NOT allowed. In these cases, it is suggested to replace them respectively with "air quality control" i.e. by removing superfluous text, "disused quarries" "quarries" i.e. by separating the different keywords, "law 190-2012" i.e. by inserting a "-", and so on.)
                                </PopoverBody>
                            </PopoverContent>
                      </Popover>
                    </Flex>
                    <Input value={payloadUploadMetadata.newTagName} onChange={(e) => { handleChangePayloadUploadMetadata(e, 'newTagName') }} />
                  </FormControl>

                  <FormControl as="fieldset" mb={4} >
                    <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.tagDescription')}:</FormLabel>
                    <Input value={payloadUploadMetadata.newTagDescription} onChange={(e) => { handleChangePayloadUploadMetadata(e, 'newTagDescription') }} />
                  </FormControl>

                 
                  
                  <FormControl display='flex' alignItems='center' mb={4}>
                    <FormLabel htmlFor='email-alerts' mb='0'>{t('catalog.stagingArea.metadataModal.isDatasetFromMlProcessing')}</FormLabel>
                    <Switch
                      id='generatedByML'
                      isChecked={payloadUploadMetadata.generatedByML}
                      onChange={(e) =>{ handleChangePayloadUploadMetadata(e.target.checked, "generatedByML"); e.target.checked ? setMaxNumberPage(9): setMaxNumberPage(7) }}
                    />
                  </FormControl>



                  {!payloadUploadMetadata.generatedByML && (
                      <FormControl display='flex' alignItems='center'>                  
                      <Flex align="center">
                        <FormLabel htmlFor='email-alerts' mb='0'>{t('catalog.stagingArea.metadataModal.isProcessed')}</FormLabel>
                        <Switch
                          id='provElab'
                          isChecked={payloadUploadMetadata.prov_elab}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            handleChangePayloadUploadMetadata(isChecked, "prov_elab");
                            if (!isChecked) {
                           
                              handleRemoveKeyPayloadUploadMetadata('type_elab')
                              handleRemoveKeyPayloadUploadMetadata('ds_source_urls')
                              handleChangePayloadUploadMetadata(false, "ext_proccesing");
                            }
                          }}
                          // onChange={(e) => handleChangePayloadUploadMetadata(e.target.checked, "prov_elab")}
                        />
                        <Popover placement="top">
                            <PopoverTrigger>
                                <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                    <MdInfo size={20} />
                                </Button>
                            </PopoverTrigger>
                              <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Is processed?</Text></PopoverHeader>
                                  <PopoverBody>
                                    It is used to identify whether the data set was produced by processing by the platform
                                    (It is a manually entered YES/NO metadata)
                                  </PopoverBody>
                              </PopoverContent>
                          </Popover>
                      </Flex>
                    </FormControl>
                  )}

                

                  {!payloadUploadMetadata.generatedByML && payloadUploadMetadata.prov_elab && (
                    <FormControl as="fieldset" mb={4} isRequired>
                      <Flex align="center">
                        <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.insertDescription')}</FormLabel>
                        <Popover placement="top">
                            <PopoverTrigger>
                                <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                    <MdInfo size={20} />
                                </Button>
                            </PopoverTrigger>
                              <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Insert description :</Text></PopoverHeader>
                                  <PopoverBody>
                                    Description of processing applied (mandatory if the source of processing is equal to YES).
                                  </PopoverBody>
                              </PopoverContent>
                          </Popover>
                      </Flex>
                      <Input
                        value={payloadUploadMetadata.type_elab}
                        onChange={(e) => handleChangePayloadUploadMetadata(e.target.value, "type_elab")}
                      />
                    </FormControl>
                  )}
                  {!payloadUploadMetadata.generatedByML &&payloadUploadMetadata.prov_elab && (
                    <FormControl display='flex' alignItems='center'>
                      <FormLabel htmlFor='email-alerts' mb='0'>{t('catalog.stagingArea.metadataModal.externalDatasetProcessing')}</FormLabel>
                      <Switch
                        id='ext_proccesing'
                        isChecked={payloadUploadMetadata.ext_proccesing}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          handleChangePayloadUploadMetadata(isChecked, "ext_proccesing");
                          if (!isChecked) {
                            

                            handleRemoveKeyPayloadUploadMetadata('ds_source_urls')
                          }
                        }}
                        // onChange={(e) => handleChangePayloadUploadMetadata(e.target.checked, "ext_proccesing")}
                      />
                    </FormControl>
                  )}
                  {!payloadUploadMetadata.generatedByML && payloadUploadMetadata.prov_elab && payloadUploadMetadata.ext_proccesing && (
                    <FormControl as="fieldset" mb={4} isRequired>
                      <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.urlsDatasetOrigin')}</FormLabel>
                      <Input
                        value={payloadUploadMetadata.ds_source_urls}
                        onChange={(e) => handleUrlsChange(e.target.value)}
                        title= {t('catalog.stagingArea.metadataModal.exempleInsertUrls')}
                        placeholder= {t('catalog.stagingArea.metadataModal.exempleInsertUrls')}
                      />
                    </FormControl>
                  )}
                </>
              )}
                 {page === 8 && (
                <>



                            <FormControl mb={4} >
                                             <FormLabel>{t('catalog.stagingArea.metadataModal.qualityInput')}</FormLabel>
                                             <Select name="inputQuality" placeholder={t('catalog.stagingArea.metadataModal.selectLevel')} value={payloadValidationMetadataMl.input_data_quality} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, input_data_quality:e.target.value});}}>
                                               <option value="A">A: Official resources & admin data</option>
                                               <option value="B">B: Other publishable sources</option>
                                               <option value="C">C: Other (internal use)</option>
                                             </Select>
                                           </FormControl>
                              <FormControl mb={4} >
                                <FormLabel>{t('catalog.stagingArea.metadataModal.qualityInputMotivation')}</FormLabel>
                                <Textarea name="inputQualityMotivation" placeholder={t('catalog.stagingArea.metadataModal.explainRanking')}  value={payloadValidationMetadataMl.ida_motivation} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, ida_motivation:e.target.value});}} />
                              </FormControl>
                              <FormControl mb={4} >
                                <FormLabel>{t('catalog.stagingArea.metadataModal.qualityProcessing')}</FormLabel>
                                <Select name="processQuality" placeholder={t('catalog.stagingArea.metadataModal.selectLevel')}  value={payloadValidationMetadataMl.process_quality} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, process_quality:e.target.value});}}>
                                  <option value="A">A: High documentation & repeatability</option>
                                  <option value="B">B: Documentation & traceability</option>
                                  <option value="C">C: Other (less than B)</option>
                                </Select>
                              </FormControl>
                              <FormControl mb={4} >
                                <FormLabel>{t('catalog.stagingArea.metadataModal.qualityProcessingMotivation')}</FormLabel>
                                <Textarea name="processQualityMotivation" placeholder={t('catalog.stagingArea.metadataModal.explainRanking')}  value={payloadValidationMetadataMl.pq_motivation} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, pq_motivation:e.target.value});}} />
                              </FormControl>
                              <FormControl mb={4} >
                            <FormLabel>{t('catalog.stagingArea.metadataModal.qualityModel')}</FormLabel>
                            <Select name="modelQuality" placeholder={t('catalog.stagingArea.metadataModal.selectLevel')}  value={payloadValidationMetadataMl.model_quality} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, model_quality:e.target.value});}}>
                              <option value="A">A: Cross-validation, peer review</option>
                              <option value="B">B: Forecast/inference uncertainty</option>
                              <option value="C">C: Other</option>
                            </Select>
                          </FormControl>
                          <FormControl mb={4} >
                            <FormLabel>{t('catalog.stagingArea.metadataModal.qualityModelMotivation')}</FormLabel>
                            <Textarea name="modelQualityMotivation" placeholder={t('catalog.stagingArea.metadataModal.explainRanking')} value={payloadValidationMetadataMl.mq_motivation} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, mq_motivation:e.target.value});}} />
                          </FormControl>
                             
              
              
                            </> )}

                {page === 9 && (
                  <>
                        {/* Papers on Modelling and Validation */}
                    <FormControl mb={4}>
                        <FormLabel>
                        {t('catalog.stagingArea.metadataModal.papersType')}
                        </FormLabel>
                        <Select
                          placeholder={t('catalog.stagingArea.metadataModal.selectPapersType')}
                          value={papersType}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setPapersType(selectedValue);
                            setPayloadValidationMetadataMl({
                              ...payloadValidationMetadataMl,
                              papers_type: selectedValue === "" ? [] : [selectedValue]
                            });
                          }}
                        >
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                  
                      <FormControl mb={4}>
                        <FormLabel>{t('catalog.stagingArea.metadataModal.papersUrl')}</FormLabel>
                        <InputGroup>
                          <Input 
                            placeholder={t('catalog.stagingArea.metadataModal.enterDocumentUrl')} 
                            value={newPaperUrl} 
                            onChange={(e) => setNewPaperUrl(e.target.value)} 
                          />
                          <InputRightElement width="4.5rem">
                            <Button 
                              h="1.75rem" 
                              size="sm" 
                              colorScheme="teal"
                              onClick={handleAddPaperUrl}
                            >
                              {t('catalog.stagingArea.metadataModal.add')}
                            </Button>
                          </InputRightElement>
                        </InputGroup>
                      </FormControl>
                      {payloadValidationMetadataMl.papers_urls.length >0 && (
                        <Box mt={2} mb={4}>
                          <VStack align="stretch" spacing={2}>
                            {payloadValidationMetadataMl.papers_urls.map((url, index) => (
                              <Box key={index} p={2} borderWidth="1px" borderRadius="md" borderColor="green.200" bg="green.50">
                                  <HStack justify="space-between">
                                    <HStack>
                                      <MdCheckCircle color="green" />
                                      <Text fontSize="sm" noOfLines={1} maxWidth="300px">
                                        {url}
                                      </Text>
                                    </HStack>
                                    <HStack>
                                      <Button 
                                        size="xs" 
                                        variant="ghost" 
                                        colorScheme="blue" 
                                        leftIcon={<FaExternalLinkAlt />} 
                                        onClick={() => window.open(url, '_blank')}
                                      >
                                        {t('catalog.stagingArea.metadataModal.open')}
                                      </Button>
                                      <Button 
                                        size="xs"
                                        variant="ghost"
                                        aria-label="Remove URL" 
                                        colorScheme="red"
                                        leftIcon={<MdDelete />}
                                        onClick={() => handleRemovePaperUrl(index)}
                                      >
                                        {t('catalog.stagingArea.metadataModal.remove')}
                                      </Button>
                                    </HStack>
                                  </HStack>
                                </Box>
                            ))}
                          </VStack>
                        </Box>)
                      }
                    <FormControl mb={4}>
                      <FormLabel>{t('catalog.stagingArea.metadataModal.papersRef')}</FormLabel>
                      <InputGroup>
                        <Input 
                          placeholder={t('catalog.stagingArea.metadataModal.reference')} 
                          value={newPaperReference} 
                          onChange={(e) => setNewPaperReference(e.target.value)} 
                        />
                        <InputRightElement width="4.5rem">
                          <Button 
                            h="1.75rem" 
                            size="sm" 
                            colorScheme="teal"
                            onClick={handleAddPaperReference}
                          >
                            {t('catalog.stagingArea.metadataModal.add')}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                    </FormControl>
                  {payloadValidationMetadataMl.papers_reference.length >0 && (
                    <Box mt={2} mb={4}>
                      <VStack align="stretch" spacing={2}>
                        {payloadValidationMetadataMl.papers_reference.map((url, index) => (
                          <Box key={index} p={2} borderWidth="1px" borderRadius="md" borderColor="green.200" bg="green.50">
                            <HStack justify="space-between">
                              <HStack>
                                <MdCheckCircle color="green" />
                                <Text fontSize="sm" noOfLines={1} maxWidth="300px">
                                  {url}
                                </Text>
                              </HStack>
                              <HStack>
                                <Button 
                                  size="xs" 
                                  variant="ghost" 
                                  colorScheme="blue" 
                                  leftIcon={<FaExternalLinkAlt />} 
                                  onClick={() => window.open(url, '_blank')}
                                >
                                  {t('catalog.stagingArea.metadataModal.open')}
                                </Button>
                                <Button 
                                  size="xs"
                                  variant="ghost"
                                  aria-label="Remove URL" 
                                  colorScheme="red"
                                  leftIcon={<MdDelete />}
                                  onClick={() => handleRemovePaperReference(index)} 
                                >
                                  {t('catalog.stagingArea.metadataModal.remove')}
                                </Button>
                              </HStack>
                            </HStack>
                          </Box>
                        ))}
                      </VStack>
                    </Box>)
                  }
                               <FormControl mb={4}>
                                 <FormLabel>{t('catalog.stagingArea.metadataModal.validationType')} </FormLabel>
                                 <Textarea name="validationType" placeholder={t('catalog.stagingArea.metadataModal.describeValidation')} value={payloadValidationMetadataMl.validation_type} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, validation_type:e.target.value})}} />
                               </FormControl>
                               <FormControl mb={4}>
                                 <FormLabel>{t('catalog.stagingArea.metadataModal.validationVariables')}</FormLabel>
                                 <Checkbox name="validationVariables" value={payloadValidationMetadataMl.has_validation_variables}   onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, has_validation_variables:e.target.checked});}}>{t('catalog.stagingArea.metadataModal.validationVariablesCheck')}</Checkbox>
                               </FormControl>

                               {payloadValidationMetadataMl.has_validation_variables  && (
                                  <FormControl mb={4}>
                                    <FormLabel>{t('catalog.stagingArea.metadataModal.validationVariableNames')}</FormLabel>
                                      <Input name="validationVariableNames" value={payloadValidationMetadataMl.validation_variables} placeholder={t('catalog.stagingArea.metadataModal.describeValidationVariableNames')} onChange={(e)=>{setPayloadValidationMetadataMl({ ...payloadValidationMetadataMl, validation_variables:e.target.value})}} />
                                  </FormControl>
                               )}


                               
              {payloadUploadMetadata.generatedByML && (
                      <FormControl display='flex' alignItems='center'>                  
                      <Flex align="center">
                        <FormLabel htmlFor='email-alerts' mb='0'>{t('catalog.stagingArea.metadataModal.isProcessed')}</FormLabel>
                        <Switch
                          id='provElab'
                          isChecked={payloadUploadMetadata.prov_elab}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            handleChangePayloadUploadMetadata(isChecked, "prov_elab");
                            if (!isChecked) {
                              
                              handleRemoveKeyPayloadUploadMetadata('type_elab')
                              handleRemoveKeyPayloadUploadMetadata('ds_source_urls')
                              handleChangePayloadUploadMetadata(false, "ext_proccesing");
                            }
                          }}
                          // onChange={(e) => handleChangePayloadUploadMetadata(e.target.checked, "prov_elab")}
                        />
                        <Popover placement="top">
                            <PopoverTrigger>
                                <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                    <MdInfo size={20} />
                                </Button>
                            </PopoverTrigger>
                              <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Is processed?</Text></PopoverHeader>
                                  <PopoverBody>
                                    It is used to identify whether the data set was produced by processing by the platform
                                    (It is a manually entered YES/NO metadata)
                                  </PopoverBody>
                              </PopoverContent>
                          </Popover>
                      </Flex>
                    </FormControl>
                  )}

                

                  {payloadUploadMetadata.prov_elab && (
                    <FormControl as="fieldset" mb={4} isRequired>
                    <Flex align="center">
                      <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.insertDescription')}</FormLabel>
                      <Popover placement="top">
                          <PopoverTrigger>
                              <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                  <MdInfo size={20} />
                              </Button>
                          </PopoverTrigger>
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Insert description :</Text></PopoverHeader>
                                <PopoverBody>
                                  Description of processing applied (mandatory if the source of processing is equal to YES).
                                </PopoverBody>
                            </PopoverContent>
                        </Popover>
                    </Flex>
                    <Input
                      value={payloadUploadMetadata.type_elab}
                      onChange={(e) => handleChangePayloadUploadMetadata(e.target.value, "type_elab")}
                    />
                  </FormControl>
                  )}
                  {payloadUploadMetadata.prov_elab && (
                    <FormControl display='flex' alignItems='center'>
                    <FormLabel htmlFor='email-alerts' mb='0'>{t('catalog.stagingArea.metadataModal.externalDatasetProcessing')}</FormLabel>
                    <Switch
                      id='ext_proccesing'
                      isChecked={payloadUploadMetadata.ext_proccesing}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        handleChangePayloadUploadMetadata(isChecked, "ext_proccesing");
                        if (!isChecked) {
                          handleRemoveKeyPayloadUploadMetadata("ds_source_urls");
                          
                        }
                      }}
                      // onChange={(e) => handleChangePayloadUploadMetadata(e.target.checked, "ext_proccesing")}
                    />
                  </FormControl>
                  )}
                  {payloadUploadMetadata.ext_proccesing && (
                    <FormControl as="fieldset" mb={4} isRequired>
                      <FormLabel fontSize="12px">{t('catalog.stagingArea.metadataModal.urlsDatasetOrigin')}</FormLabel>
                      <Input
                        value={payloadUploadMetadata.ds_source_urls}
                        onChange={(e) => handleUrlsChange(e.target.value)}
                        title= {t('catalog.stagingArea.metadataModal.exempleInsertUrls')}
                        placeholder= {t('catalog.stagingArea.metadataModal.exempleInsertUrls')}
                      />
                    </FormControl>
                  )}
                              
                              
                             </> )}



            </ModalBody>
            <ModalFooter>

              <Flex justify="center" alignItems="center" mt={4} width="100%">
                {page > 1 && page < maxNumberPage && (
                  <>
                    <IconButton
                      marginRight={"7%"} // Margine destro quando entrambi i bottoni sono visibili
                      icon={<ArrowBackIcon />}
                      onClick={() => setPage(page - 1)}
                      aria-label="Pagina precedente"
                      colorScheme="teal"
                    />
                    <IconButton
                      icon={<ArrowForwardIcon />}
                      onClick={() => setPage(page + 1)}
                      aria-label="Pagina successiva"
                      colorScheme="teal"
                    />
                  </>
                )}

                {page === 1 && (
                  <IconButton
                    icon={<ArrowForwardIcon />}
                    onClick={() => setPage(page + 1)}
                    aria-label="Pagina successiva"
                    colorScheme="teal"
                  />
                )}

                {page === maxNumberPage && (
                  <IconButton
                    icon={<ArrowBackIcon />}
                    onClick={() => setPage(page - 1)}
                    aria-label="Pagina precedente"
                    colorScheme="teal"
                  />
                )}
              </Flex>


              {page === maxNumberPage? (
                <Button colorScheme="blue" onClick={handleOnClickConcludi}>
                  {t('catalog.stagingArea.metadataModal.finish')}
                </Button>
              ) : (
                ""
              )}

            </ModalFooter>
          </ModalContent>
        </Modal>

      ):null}

        {step === 2 && metadataEnteredData != null && metadataEnteredData.length > 0 ? (

          // <ModalContent>
          //   <ModalHeader>{t('catalog.stagingArea.metadataModal.enteringFieldDescriptions')}</ModalHeader>
          //   <ModalCloseButton />
          //   <ModalBody overflowY="auto" maxHeight="600px"> {/* Imposta un'altezza massima per il contenuto */}
          //     {metadataEnteredData.map(item => (
          //       <FormControl mb={4} isRequired key={item.name}>
          //         <FormLabel>{t('catalog.stagingArea.metadataModal.name')}: {item.name}, {t('catalog.stagingArea.metadataModal.type')}: {item.type}</FormLabel>
          //         <Input placeholder="Inserire Descrizione" onChange={(e) => handleChangeDescriptionMetadata(e, item)} />
          //       </FormControl>
          //     ))}
          //   </ModalBody>
          //   <ModalFooter>
          //     <Flex justify="center" width="100%">
          //       <Button marginRight="6%" onClick={handleOnClickAnnulla}>
          //         {t('catalog.stagingArea.metadataModal.cancel')}
          //       </Button>
          //       <Button onClick={handleClickInvia} isLoading={isSubmitting}>
          //         {t('catalog.stagingArea.metadataModal.submit')}
          //       </Button>
          //     </Flex>
          //   </ModalFooter>

          // </ModalContent>


          <Modal isOpen={isOpen} onClose={() => { onClose(); setStep(null); setMetadataEntered(true); setIsModal1Open(true); setIsModal2Open(false); setIsModal3Open(false); setIsInfoModalOpen(true);}} size="xl" closeOnOverlayClick={false} trapFocus={false} >
            <ModalOverlay />
            {isModal1Open && (
              <ModalContent>
                <ModalHeader color="white" bgColor={"#0888BE"}>
                  {t("catalog.stagingArea.metadataModal.enteringFieldDescriptions")}
                  <ModalCloseButton mt={2} />
                </ModalHeader>
                <ModalBody><span dangerouslySetInnerHTML={{ __html: t('catalog.stagingArea.metadataModal.manualInsertQuestion') }} /></ModalBody>
                <ModalFooter>
                  <Button colorScheme="blue" onClick={handleManualEntry}>
                    {t("catalog.stagingArea.metadataModal.manualEntry")}
                  </Button>
                  <Button colorScheme="green" ml={6} onClick={handleUploadFile}>
                    {t("catalog.stagingArea.metadataModal.uploadFile")}
                  </Button>
                </ModalFooter>
              </ModalContent>)}
            {isModal2Open && (
              <ModalContent>
                <ModalHeader color="white" display="flex" justifyContent="space-between" bgColor={"#0888BE"}><Box>{t('catalog.stagingArea.metadataModal.uploadFileUpper')}</Box> <Box><CloseButton onClick={handleAnnulla} /></Box></ModalHeader>
                <ModalBody>
                  <Box my="2">
                    <span dangerouslySetInnerHTML={{ __html: t('catalog.stagingArea.metadataModal.uploadCsvInfo') }} />
                  </Box>
                  <Box color="red">
                    <b>{t("catalog.stagingArea.metadataModal.alertAttention")}</b> :
                  </Box>
                  <Box mb="2">
                    <span dangerouslySetInnerHTML={{ __html: t('catalog.stagingArea.metadataModal.alertCsvRule1') }} />
                  </Box>
                  <Box mb="2">
                    <span dangerouslySetInnerHTML={{ __html: t('catalog.stagingArea.metadataModal.alertCsvRule2') }} />
                  </Box>
                  <Box mb="2">
                    <span dangerouslySetInnerHTML={{ __html: t('catalog.stagingArea.metadataModal.alertCsvRule3') }} />
                  </Box>
                  <Stack spacing='4'>
                    {/* <Box>
                                  <FormControl>
                                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t("catalog.stagingArea.metadataModal.selectFileFormat")}:</FormLabel>
                                    <Select onChange={(e) => handleChangePayloadRequest(e, "fileFormat")} >
                                      {fileFormats.map(option => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Box> */}
                    <Box>
                      <FormControl isRequired>
                        <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' >{t("catalog.stagingArea.metadataModal.selectFile")}:</FormLabel>
                        <Input ref={fileSelectorRef} placeholder='Select file' name='file' type='file' bg='white' accept=".csv" onChange={(e) => handleChangePayloadRequest(e, "file")} />
                      </FormControl>
                    </Box>
                  </Stack>
                </ModalBody>
                <ModalFooter>
                  {/* <Button colorScheme='green' mr={3} onClick={uploadDataset}>
                                {t('catalog.dataset.upload')}
                  
                              </Button> */}
                  <Button onClick={handleAnnulla}>{t("catalog.stagingArea.metadataModal.cancel")}</Button>
                  <Button colorScheme="green" ml={3} onClick={handleUploadSubmit}>
                    {t("catalog.stagingArea.metadataModal.upload")}
                  </Button>
                </ModalFooter>
              </ModalContent>
            )}
            {isConfirmModalOpen && (
              <Modal isCentered isOpen={isConfirmModalOpen} onClose={handleCancelUpload} closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader>{t("catalog.stagingArea.metadataModal.headerConfirm")}</ModalHeader>
                  <ModalBody>
                    <Text mb={4}>
                      {t("catalog.stagingArea.metadataModal.verifyMessage")}:
                    </Text>
                    <UnorderedList spacing={2} mb={4}>
                      <ListItem>{t("catalog.stagingArea.metadataModal.fileFormatCorrect")}</ListItem>
                      <ListItem>{t("catalog.stagingArea.metadataModal.dataCompleteness")}</ListItem>
                      <ListItem>{t("catalog.stagingArea.metadataModal.guidelines")}</ListItem>
                    </UnorderedList>
                  </ModalBody>
                  <ModalFooter>
                    <Button onClick={handleCancelUpload} colorScheme="red" mr={3}>
                      {t("catalog.stagingArea.metadataModal.cancelConfirm")}
                    </Button>
                    <Button onClick={handleConfirmUpload} colorScheme="green">
                      {t("catalog.stagingArea.metadataModal.confirm")}
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            )}
            {isModal3Open && (<ModalContent>
              <ModalHeader>
                {t("catalog.stagingArea.metadataModal.manualEntryFieldDescriptions")}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody overflowY="auto" maxHeight="600px">
                {currentItems.map((item) => (
                  <FormControl mb={4} isRequired key={item.name}>
                    <FormLabel>
                      {t("catalog.stagingArea.metadataModal.name")}: {item.name},{" "}
                      {t("catalog.stagingArea.metadataModal.type")}: {item.type}
                    </FormLabel>
                    <Input
                      placeholder={t("catalog.stagingArea.metadataModal.insertDescription")}
                      value={item && item.name && descriptionMetadataPayload && descriptionMetadataPayload.cols && descriptionMetadataPayload.cols[item.name] ? descriptionMetadataPayload.cols[item.name] : ""} // Usa lo stato locale
                      onChange={(e) => handleChangeDescriptionMetadata(e, item)}
                    />
                  </FormControl>
                ))}
              </ModalBody>
              <ModalFooter>
                <Flex justify="space-between" width="100%">
                  {currentPage > 1 && (
                    <IconButton
                      icon={<ArrowBackIcon />}
                      onClick={handlePreviousPage}
                      aria-label="Pagina precedente"
                      colorScheme="teal"
                    />
                  )}
                  {currentPage <
                    Math.ceil(metadataEnteredData.length / itemsPage) && (
                      <Button
                        onClick={handleNextPage}
                        isLoading={isSubmitting}
                        aria-label="Pagina successiva"
                        colorScheme="teal"
                        rightIcon={<ArrowForwardIcon />}
                      >
                        {t("catalog.stagingArea.metadataModal.saveProceed")}
                        {/* <IconButton
                                  icon={<ArrowForwardIcon />}
                                  onClick={handleNextPage}
                                  aria-label="Pagina successiva"
                                  colorScheme="teal"
                                /> */}
                      </Button>
                    )}
                  {currentPage ===
                    Math.ceil(metadataEnteredData.length / itemsPage) && (
                      <Flex marginLeft="auto">
                        {/* <Button marginRight="6%" onClick={handleOnClickAnnulla}>
                                  {t("catalog.stagingArea.metadataModal.cancel")}
                                  </Button> */}
                        <Button colorScheme="teal" onClick={handleClickInvia} isLoading={isSubmitting}>
                          {t("catalog.stagingArea.metadataModal.submit")}
                        </Button>
                      </Flex>
                    )}
                </Flex>
              </ModalFooter>
            </ModalContent>)}
          </Modal>

        ):null}
        <Modal
          isOpen={isInfoModalOpen}
          onClose={() => setIsInfoModalOpen(false)}
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("catalog.stagingArea.metadataModal.information")}
            <ModalCloseButton mt={2} onClick={() => setIsInfoModalOpen(false)} />
            </ModalHeader>
            <ModalBody>
              <Text>
                {t("catalog.stagingArea.metadataModal.infoNextStep")} ( <Icon boxSize={4} as={EditIcon} color="#0b4e5aff" _hover={{ color: "#0b4e5aff", bg: "transparent" }}/> )
              </Text>
            </ModalBody>
            <ModalFooter>
            </ModalFooter>
          </ModalContent>
        </Modal>

    </DndProvider>
  );
}

export default MetadataModal;
